<template>
    <Transition name="fade">
        <div v-if="show"
            class="text-14px font-500 z-999999 absolute bottom-90px w-90% rounded-10px p-13px text-center left-50% transform -translate-x-1/2 transform-origin-center bg-#fff color-#000!">
            <slot>
                {{ t('thinkingToast.notAvailable') }}
            </slot>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

interface Props {
    show: boolean
    duration?: number // 自动隐藏时长（毫秒），默认 2000ms
}

const props = withDefaults(defineProps<Props>(), {
    duration: 2000
})

const emit = defineEmits<{
    (e: 'update:show', value: boolean): void
}>()

let timer: NodeJS.Timeout | null = null

// 监听 show 变化，自动设置定时器
watch(() => props.show, (newVal) => {
    // 清除之前的定时器
    if (timer) {
        clearTimeout(timer)
        timer = null
    }

    // 如果显示，设置自动隐藏定时器
    if (newVal && props.duration > 0) {
        timer = setTimeout(() => {
            emit('update:show', false)
            timer = null
        }, props.duration)
    }
})

// 组件卸载时清理定时器
import { onUnmounted } from 'vue'
onUnmounted(() => {
    if (timer) {
        clearTimeout(timer)
        timer = null
    }
})
</script>

<style scoped lang="scss">
// 淡入淡出动画
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>

